import { tv } from "tailwind-variants";
import { Size } from "../helpers/helpers.js";

export const selectStyle = tv({
  slots: {
    button:
      "flex min-w-[100px] cursor-default items-center justify-stretch rounded-md bg-white text-left text-foreground shadow-xs ring-1 ring-border-strong select-none ring-inset focus:outline-hidden focus-visible:ring-2 focus-visible:ring-indigo-600 disabled:cursor-not-allowed disabled:opacity-50 data-[focus-visible]:ring-2 data-[focus-visible]:ring-indigo-600",
    value: "min-w-0 flex-auto truncate",
    placeholder: "min-w-0 flex-auto truncate text-gray-400",
    chevron: "shrink-0 text-gray-400",
  },
  variants: {
    isInvalid: {
      true: {
        button:
          "ring-2 ring-red-500 focus-visible:ring-red-500 data-[focus-visible]:ring-red-500",
      },
    },
    size: {
      [Size.SMALL]: {
        button: "h-7 min-h-7 gap-1.5 px-2 py-0.5 text-xs leading-4",
        chevron: "-mr-0.5 size-4",
      },
      [Size.MEDIUM]: {
        button: "h-8 min-h-8 gap-2 px-2.5 py-1 text-sm leading-5",
        chevron: "-mr-1 size-5",
      },
    },
  },
  defaultVariants: {
    size: Size.MEDIUM,
  },
});
